var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.amount)?_c('v-layout',{attrs:{"d-flex":"","shrink":""}},[_c('div',[_vm._v(_vm._s(_vm.amount))]),_c('v-img',{staticClass:"rupee",attrs:{"src":_vm.rupee,"width":_vm.size,"height":_vm.size,"contain":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }